import React from "react";
import AppHeading from "../layout/parts/app-heading";
import AppBody from "../layout/parts/app-body";
import axios, {responseHandler, errorHandler} from "../requests/axios.js";
import {toast} from "react-toastify";
import GstvAgGrid from "../components/gstv-ag-grid";
import Loader from "../common/loader";

export default function OneLinkBridgePage() {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const columnDefs = React.useMemo(() => [
        {field: "id_one_link_bridge_record", headerName: "ID"},
        {field: "session_id", headerName: "Session ID"},
        {field: "state", headerName: "State"},
        {field: "action", headerName: "Action"},
        {field: "tv_label", headerName: "TV Label"},
        {field: "tv_ip", headerName: "TV IP"},
        {field: "occurred_at", headerName: "Occurred At"},
        {field: "user_agent", headerName: "User Agent"},
        {field: "ip_address", headerName: "IP Address"},
        {field: "inserted_at", headerName: "Inserted At"},
    ], []);

    const defaultColDef = React.useMemo(() => ({
        filter: true,
        editable: false,
        sortable: true,
        resizable: true,
        width: 180,
    }), []);

    React.useEffect(() => {
        setLoading(true);
        axios
            .get("api/pages/one-link-bridge")
            .then(
                responseHandler((response) => {
                    setData(response.data);
                })
            )
            .catch(
                errorHandler((e) => {
                    console.error(e);
                    toast.error("Error loading One Link Bridge data");
                })
            )
            .finally(() => setLoading(false));
    }, []);

    return (
        <React.Fragment>
            <AppHeading title="One Link Bridge Analytics" subtitle="Latest 1000 records"/>
            <AppBody loading={loading}>
                <div className="one-link-bridge-page">
                    <div className="one-link-bridge-page__lower">
                        {loading ? (
                            <div>
                                <Loader/>
                            </div>
                        ) : (
                            <GstvAgGrid
                                data={data}
                                defs={columnDefs}
                                defaultDef={defaultColDef}
                            />
                        )}
                    </div>
                </div>
            </AppBody>
        </React.Fragment>
    );
}
